import React, { useState } from 'react';
import SideMenu from './SideMenu';
import Header from './Header';
import { NavLink, Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const menuItems = [
  { to: '/home', label: 'Painel' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/sensors', label: 'Sensores' },
  { to: '/reports', label: 'Relatórios' },
  { to: '/farm-list', label: 'Fazendas' },
  { to: '/harvest-history', label: 'Histórico de Safra' },
  { to: '/stock-control', label: 'Controle de Estoque' },
  { to: '/settings', label: 'Configuração' },
];

const PrivateLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#0f172a] overflow-x-hidden">
      {/* Menu lateral fixo em telas grandes */}
      <div className="hidden md:flex">
        <SideMenu />
      </div>

      {/* Menu mobile animado */}
      <AnimatePresence>
        {menuOpen && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden fixed top-0 left-0 w-full bg-slate-800 z-50 p-4 space-y-2"
          >
            <div className="flex justify-between items-center">
              <h1 className="text-white text-lg font-bold">Sense Cloud</h1>
              <button onClick={() => setMenuOpen(false)} className="text-white text-sm underline">Fechar</button>
            </div>
            {menuItems.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `block py-2 text-white font-medium ${
                    isActive ? 'text-green-400' : 'hover:text-green-200'
                  }`
                }
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </NavLink>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>

      {/* Conteúdo principal */}
      <div className="flex-1 flex flex-col w-full">
        {/* Header com botão do menu mobile */}
        <Header onMenuClick={() => setMenuOpen(!menuOpen)} />
        <div className="p-4 sm:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;